import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_LOCALE = 'en-US';
@Pipe({
  standalone: true,
  name: 'uiCheckinCheckoutDisplay',
})
export class CheckinCheckoutDisplayPipe implements PipeTransform {
  transform(checkin: string | Date | null, checkout: string | Date | null, showTime = true): string {
    if (!checkin || !checkout) {
      return '...';
    }

    const checkinDate = new Date(checkin);
    const checkoutDate = new Date(checkout);
    const checkinDay = formatDate(checkinDate, 'MMM d', DEFAULT_LOCALE);
    const checkoutDay = formatDate(checkoutDate, 'MMM d', DEFAULT_LOCALE);
    if (showTime) {
      const checkinTime = formatDate(checkinDate, 'ha', DEFAULT_LOCALE);
      const checkoutTime = formatDate(checkoutDate, 'ha', DEFAULT_LOCALE);
      return `${checkinDay} • ${checkinTime} → ${checkoutDay} • ${checkoutTime}`;
    }
    return `${checkinDay} → ${checkoutDay}`;
  }
}
